module.exports = __webpack_public_path__ + "static/media/dressify.4c945829.webp";